import React from 'react';
import ACSERVICE from './Components/ac-service';
import CHIMNEYSERVICE from './Components/chimney-service';
import FRIDGESERVICE from './Components/fridge-service';
import HOME from './Components/home';
import WASHINGMACHINESERVICECENTERNAGAPATTINAM from './Components/washing-machine-service-center-nagapattinam'
import HVAC from './Components/hvac-service';
import MICOWAVEOVENSERVICE from './Components/microwave-oven-service';
import PRIVACYPOLICY from './Components/privacy-policy';
import TERMSCONDITIONS from './Components/terms-conditions';
import TVSERVICE from './Components/tv-service';
import WASHINGMACHINESERVICE from './Components/washing-machine-service';
import WATERHEATERSERVICE from './Components/water-heater-service';
import WATERPURIFIERSERVICE from './Components/water-purifier-service';
import WASHINGMACHINESERVICECENTERMADURAI from './Components/washing-machine-service-center-madurai';
import ACSERVICECENTERTIRUNELVELI from './Components/ac-service-center-tirunelveli';
import FRIDGESERVICECENTERTIRUNELVELI from './Components/fridge-service-center-tirunelveli'
import ACSERVICECENTERINMADURAI from './Components/ac-service-center-in-madurai';
import FRIDGESERVICECENTERMADURAI from './Components/fridge-service-center-madurai';
import LEDTVSERVICECENTERINMADURAI from './Components/led-tv-service-center-in-madurai';
import MICROWAVEOVENSERVICECENTERMADURAI from './Components/microwave-oven-service-center-madurai';
import MICROWAVEOVENSERVICE from './Components/microwave-oven-service';
import ACSERVICECENTERTRICHY from './Components/ac-service-center-trichy';
import WASHINGMACHINESERVICECENTERTRICHY from './Components/washing-machine-service-center-trichy';
import WASHINGMACHINESERVICECENTERTUTICORIN from './Components/washing-machine-service-center-tuticorin';
import ACSERVICECENTERINTENKASI from './Components/ac-service-center-tenkasi';
import FRIDGESERVICECENTERTENKASI from './Components/fridge-service-center-tenkasi';
import WASHINGAMACHINESERVICECENTERTENKASI from './Components/washing-machine-service-center-tenkasi';
import WASHINGAMACHINESERVICECENTERTHANJAVUR from './Components/washing-machine-service-center-thanjavur';
import FRIDGESERVICEINVELLORE from './Components/fridge-service-in-vellore';
import ACSERVICECENTERTHIRUVARUR from './Components/ac-service-center-tiruvarur'
import FRIDGESERVICECENTERCUDDALORE from'./Components/fridge-service-center-cuddalore'
import WASHINGMACHINESERVICECENTERCUDDALORE from './Components/washing-machine-service-center-cuddalore';
import WASHINGMACHINESERVICECENTERPUDUKKOTTAI from './Components/washing-machine-service-center-pudukottai';
import ACSERVICECENTERRAMNAD from './Components/ac-service-center-ramnad';
import ACSERVICECENTERSIVAGANGA from './Components/ac-service-center-sivaganga';
import FRIDGESERVICECENTERTIRUPPUR from './Components/fridge-service-center-tiruppur';
import ACSERVICECENTERVILLUPURAM from './Components/ac-service-center-villupuram';
import FRIDGESERVICECENTERVILLUPURAM from './Components/fridge-service-center-villupuram';
import WASHINGMACHINESERVICECENTERVILLUPURM from './Components/washing-machine-service-center-villupuram';
import WASHINGMACHINESERVICECENTERINDINDIGUL  from './Components/washing-machine-service-center-in-dindigul';
import WASHINGMACHINESERVICECENTERINTHENI  from './Components/washing-machine-service-center-theni';
import ACSERVICECENTERVIRUDHUNAGAR from './Components/ac-service-center-virudhunagar';
import WASHINGMACHINESERVICECENTER from './Components/washing-machine-service-center';
import HAIERWASHINGMACHINESERVICECENTERINMADURAI from './Components/haier-washing-machine-service-center-in-madurai';
import HAIERWASHINGMACHINESERVICECENTERMADURAI from './Components/haier-washing-machine-service-center-madurai';
import HAIERWASHINGMACHINESERVICECENTER from './Components/haier-washing-machine-service-center';
import HAIERWASHINGMACHINESERVICEINMADURAI from './Components/haier-washing-machine-service-in-madurai';
import HAIERWASHINGMACHINESERVICE from './Components/haier-washing-machine-service';
import IFBCUSTOMERCAREMADURAI from './Components/ifb-customer-care-madurai';

import IFBWASHINGMACHINESERVICECENTERINMADURAI from './Components/ifb-washing-machine-service-center-in-madurai';
import IFBWASHINGMACHINESERVICECENTERMADURAI from './Components/ifb-washing-machine-service-center-madurai';
import IFBWASHINGMACHINESERVICECENTER from './Components/ifb-washing-machine-service-center';
import IFBWASHINGMACHINESERVICEINMADURAI from './Components/ifb-washing-machine-service-in-madurai';
import IFBWASHINGMACHINESERVICEMADURAI from './Components/ifb-washing-machine-service-madurai';
import IFBWASHINGMACHINESERVICE from './Components/ifb-washing-machine-service';
import LGWASHINGMACHINESERVICECENTERINMADURAI from './Components/lg-washing-machine-service-center-in-madurai';
import LGWASHINGMACHINESERVICECENTERMADURAI from './Components/lg-washing-machine-service-center-madurai';
import LGWASHINGMACHINESERVICECENTER from './Components/lg-washing-machine-service-center';
import LGWASHINGMACHINESERVICEINMADURAI from './Components/lg-washing-machine-service-in-madurai';
import LGWASHINGMACHINESERVICEMADURAI from './Components/lg-washing-machine-service-madurai';

import LGWASHINGMACHINESERVICE from './Components/lg-washing-machine-service';
import SAMSUNGWASHINGMACHINESERVICECENTERINMADURAI from './Components/samsung-washing-machine-service-center-in-madurai';
import SAMSUNGWASHINGMACHINESERVICECENTERMADURAI from './Components/samsung-washing-machine-service-center-madurai';
import SAMSUNGWASHINGMACHINESERVICECENTER from './Components/samsung-washing-machine-service-center';
import SAMSUNGWASHINGMACHINESERVICEINMADURAI from './Components/samsung-washing-machine-service-in-madurai';
import SAMSUNGWASHINGMACHINESERVICEMADURAI from './Components/samsung-washing-machine-service-madurai';
import SAMSUNGWASHINGMACHINESERVICE from './Components/samsung-washing-machine-service';
import WHIRLPOOLWASHINGMACHINESERVICECENTERINMADURAI from './Components/whirlpool-washing-machine-service-center-in-madurai';
import WHIRLPOOLWASHINGMACHINESERVICECENTERMADURAI from './Components/whirlpool-washing-machine-service-center-madurai';
import WHIRLPOOLWASHINGMACHINESERVICECENTER from './Components/whirlpool-washing-machine-service-center';
import WHIRLPOOLWASHINGMACHINESERVICEINMADURAI from './Components/whirlpool-washing-machine-service-in-madurai';
import WHIRLPOOLWASHINGMACHINESERVICEMADURAI from './Components/whirlpool-washing-machine-service-madurai';
import WHIRLPOOLWASHINGMACHINESERVICE from './Components/whirlpool-washing-machine-service';
import BOSCHWASHINGMACHINESERVICECENTERINMADURAI from './Components/bosch-washing-machine-service-center-in-madurai';
import BOSCHWASHINGMACHINESERVICECENTERMADURAI from './Components/bosch-washing-machine-service-center-madurai';
import BOSCHWASHINGMACHINESERVICECENTER from './Components/bosch-washing-machine-service-center';
import BOSCHWASHINGMACHINESERVICEINMADURAI from './Components/bosch-washing-machine-service-in-madurai';
 import  BOSCHWASHINGMACHINESERVICEMADURAI from './Components/bosch-washing-machine-service-madurai';
import BOSCHWASHINGMACHINESERVICE from './Components/bosch-washing-machine-service';
import BOSCHWASHINGMACHINESERVICENEARME from './Components/bosch-washing-machine-service-near-me';
import HAIERWASHINGMACHINESERVICENEARME from './Components/haier-washing-machine-service-near-me';
import IFBWASHINGMACHINESERVICENEARME from './Components/ifb-washing-machine-service-near-me';
import LGWASHINGMACHINESERVICENEARME from './Components/lg-washing-machine-service-near-me';
import LGWASHINGMACHINECUSTOMERCARE from './Components/lg-washing-machine-customer-care';
import SAMSUNGWASHINGMACHINESERVICENEARME from './Components/samsung-washing-machine-service-near-me';
import WHIRLPOOLWASHINGMACHINESERVICENEARME from './Components/whirlpool-washing-machine-service-near-me';
import BOSCHWASHINGMACHINESERVICECENTERNEARME from './Components/bosch-washing-machine-service-center-near-me';
import HAIERWASHINGMACHINESERVICECENTERNEARME from './Components/haier-washing-machine-service-center-near-me';
import IFBWASHINGMACHINESERVICECENTERNEARME from './Components/ifb-washing-machine-service-center-near-me';
import LGWASHINGMACHINESERVICECENTERNEARME from './Components/lg-washing-machine-service-center-near-me';
import SAMSUNGWASHINGMACHINESERVICECENTERNEARME from './Components/samsung-washing-machine-service-center-near-me';
import HAIERWASHINGMACHINESERVICEMADURAI from './Components/haier-washing-machine-service-madurai'
import WHIRLPOOLWASHINGMACHINESERVICECENTERNEARME from './Components/whirlpool-washing-machine-service-center-near-me';
import LGCUSTOMERCAREMADURAI  from './Components/lg-customer-care-madurai'
import WHIRLPOOLCUSTOMERCAREMADURAI from './Components/whirlpool-customer-care-madurai'
// import SAMSUNGHOMEAPPLICANCESERVICEMADURAI from './Components/samsung-customer-care-madurai'
import HAIERCUSTOMERCAREMADURAI from './Components/haier-customer-care-madurai'
import BOSCHCUSTOMERCAREMADURAI from './Components/bosch-customer-care-madurai'
// import  WASHINGMACHIEREPAIR  from './Components/washing-machine-repair'
// import SAMSUNGCUSTOMERCAREMADURAI from './Components/samsung-customer-care-madurai'
import SAMSUNGCUSTOMERCAREMADURAI from './Components/samsung-customer-care-madurai';
import ERROR from './Components/404';
   
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Forbidden403 from './Components/403';  
 import SparePriceList from './Components/SparePriceList';
 import SpareCard from './Components/SpareCard';
 import SpareDsb from './Components/SpareDsb';
 import AMCComponent from './Components/AMCComponent';
 import About from './Header&Footer/About';
 // Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Bootstrap JS (includes dropdown functionality)
// import 'bootstrap/dist/js/bootstrap.bundle.min';


// import  Unauthorized401 from './Components/401'
 


function App() {
  
  return (
    <>
      <Router>
    
        <div>
          <Routes>
             

            <Route path='/' element={<HOME />} />
            <Route path='/404' element={<ERROR />} />
            <Route path='/403' element={<Forbidden403/>}/>
         <Route path='/spare-price-list' element={<SparePriceList/>}/>
         <Route path='/sparedsb' element={<SpareDsb/>}/>
         <Route path='/sparecard' element={<SpareCard/>}/>
          <Route path='/amc' element={<AMCComponent />}/>
          <Route path='/about' element={<About/>}/>

            <Route path='/ac-service' element={<ACSERVICE />} />
            <Route path='/chimney-service' element={<CHIMNEYSERVICE />} />
            <Route path='/fridge-service' element={<FRIDGESERVICE />} />
            <Route path='/hvac-service' element={<HVAC />} />
            <Route path='/microwave-oven-service' element={<MICOWAVEOVENSERVICE />} />
            <Route path='/tv-service' element={<TVSERVICE />} />
            <Route path='/washing-machine-service' element={<WASHINGMACHINESERVICE />} />
            <Route path='/water-heater-service' element={<WATERHEATERSERVICE />} />
            <Route path='/water-purifier-service' element={<WATERPURIFIERSERVICE />} />
            <Route path='/washing-machine-service-center-madurai' element={<WASHINGMACHINESERVICECENTERMADURAI />} />
            <Route path='/ac-service-center-tirunelveli' element={<ACSERVICECENTERTIRUNELVELI />} />
            <Route path='/fridge-service-center-tirunelveli' element={<FRIDGESERVICECENTERTIRUNELVELI />} />1
            <Route path='/ac-service-center-in-madurai' element={<ACSERVICECENTERINMADURAI />} />
            <Route path='/fridge-service-center-madurai' element={<FRIDGESERVICECENTERMADURAI />} />
            <Route path='/led-tv-service-center-in-madurai' element={<LEDTVSERVICECENTERINMADURAI />} />
            <Route path='/microwave-oven-service-center-madurai' element={<MICROWAVEOVENSERVICECENTERMADURAI />} />
            <Route path='/microwave-oven-service' element={<MICROWAVEOVENSERVICE />} />
            <Route path='/ac-service-center-trichy' element={<ACSERVICECENTERTRICHY />} />
            <Route path='/washing-machine-service-center-trichy' element={<WASHINGMACHINESERVICECENTERTRICHY />} />
            <Route path='/washing-machine-service-center-tuticorin' element={<WASHINGMACHINESERVICECENTERTUTICORIN />} />
            <Route path='/ac-service-center-tenkasi' element={<ACSERVICECENTERINTENKASI />} />
            <Route path='/fridge-service-center-tenkasi' element={<FRIDGESERVICECENTERTENKASI />} />
            <Route path='/washing-machine-service-center-tenkasi' element={<WASHINGAMACHINESERVICECENTERTENKASI />} />
            <Route path='/washing-machine-service-center-thanjavur' element={<WASHINGAMACHINESERVICECENTERTHANJAVUR />} />
                   

            <Route path='/fridge-service-in-vellore' element={<FRIDGESERVICEINVELLORE />} />
            <Route path='/washing-machine-service-center-nagapattinam' element={<WASHINGMACHINESERVICECENTERNAGAPATTINAM />} />
            <Route path='/ac-service-center-tiruvarur' element={<ACSERVICECENTERTHIRUVARUR />} />
            <Route path='/fridge-service-center-cuddalore' element={<FRIDGESERVICECENTERCUDDALORE/>} />
            <Route path='/washing-machine-service-center-cuddalore' element={< WASHINGMACHINESERVICECENTERCUDDALORE/>} />
            <Route path='/washing-machine-service-center-pudukottai' element={<WASHINGMACHINESERVICECENTERPUDUKKOTTAI/>} />
            <Route path='/ac-service-center-ramnad' element={<ACSERVICECENTERRAMNAD/>} />
            <Route path='/ac-service-center-sivaganga' element={<ACSERVICECENTERSIVAGANGA/>} />
            <Route path='/fridge-service-center-tiruppur' element={<FRIDGESERVICECENTERTIRUPPUR/>} />
            <Route path='/ac-service-center-villupuram' element={<ACSERVICECENTERVILLUPURAM/>} />
            <Route path='/fridge-service-center-villupuram' element={<FRIDGESERVICECENTERVILLUPURAM/>} />
            <Route path='/washing-machine-service-center-theni' element={< WASHINGMACHINESERVICECENTERINTHENI/>} />
            {/* <Route path='/washing-machine-repair' element={<WASHINGMACHIEREPAIR />} /> */}
            
            <Route path='/washing-machine-service-center-villupuram' element={< WASHINGMACHINESERVICECENTERVILLUPURM/>} />
            <Route path='/washing-machine-service-center-in-dindigul' element={< WASHINGMACHINESERVICECENTERINDINDIGUL/>} />
            {/* <Route path='/washing-machine-service-center-in-theni' element={< WASHINGMACHINESERVICECENTERINTHENIz/>} /> */}
            <Route path='/ac-service-center-virudhunagar' element={<ACSERVICECENTERVIRUDHUNAGAR/>} />
            <Route path='/washing-machine-service-center' element={<WASHINGMACHINESERVICECENTER/>}/>
            <Route path='/haier-washing-machine-service-center-in-madurai' element={<HAIERWASHINGMACHINESERVICECENTERINMADURAI/>}/>
            <Route path='/haier-washing-machine-service-center-madurai' element={<HAIERWASHINGMACHINESERVICECENTERMADURAI/>}/>
            <Route path='/haier-washing-machine-service-center' element={<HAIERWASHINGMACHINESERVICECENTER/>}/>
            <Route path='/haier-washing-machine-service-in-madurai' element={<HAIERWASHINGMACHINESERVICEINMADURAI/>}/>
            <Route path='/haier-washing-machine-service-madurai' element={<HAIERWASHINGMACHINESERVICEMADURAI/>}/>
            <Route path='/haier-washing-machine-service' element={<HAIERWASHINGMACHINESERVICE/>}/>
            <Route path='/ifb-customer-care-madurai' element={<IFBCUSTOMERCAREMADURAI/>}/>
            {/* <Route path='/samsung-customer-care-madurai' element={<SAMSUNGCUSTOMERCAREMADURAI/>}/> */}
            <Route path='/ifb-washing-machine-service-center-in-madurai' element={<IFBWASHINGMACHINESERVICECENTERINMADURAI/>}/>
            <Route path='/ifb-washing-machine-service-center-madurai' element={<IFBWASHINGMACHINESERVICECENTERMADURAI/>}/>
            <Route path='/ifb-washing-machine-service-center' element={<IFBWASHINGMACHINESERVICECENTER/>}/>
            <Route path='/ifb-washing-machine-service-in-madurai' element={<IFBWASHINGMACHINESERVICEINMADURAI/>}/>
            <Route path='/ifb-washing-machine-service-madurai' element={<IFBWASHINGMACHINESERVICEMADURAI/>}/>
            <Route path='/ifb-washing-machine-service' element={<IFBWASHINGMACHINESERVICE/>}/>
            <Route path='/lg-washing-machine-service-center-in-madurai' element={<LGWASHINGMACHINESERVICECENTERINMADURAI/>}/>
            <Route path='/lg-washing-machine-customer-care' element={<LGWASHINGMACHINECUSTOMERCARE/>}/>
            <Route path='/lg-washing-machine-service-center-madurai' element={<LGWASHINGMACHINESERVICECENTERMADURAI/>}/>
            <Route path='/lg-washing-machine-service-center' element={<LGWASHINGMACHINESERVICECENTER/>}/>
            <Route path='/lg-washing-machine-service-in-madurai' element={<LGWASHINGMACHINESERVICEINMADURAI/>}/>
            <Route path='/lg-washing-machine-service-madurai' element={<LGWASHINGMACHINESERVICEMADURAI/>}/>
            <Route path='/lg-washing-machine-service' element={<LGWASHINGMACHINESERVICE/>}/>
            <Route path='/samsung-washing-machine-service-center-in-madurai' element={<SAMSUNGWASHINGMACHINESERVICECENTERINMADURAI/>}/>
            <Route path='/samsung-washing-machine-service-center-madurai' element={<SAMSUNGWASHINGMACHINESERVICECENTERMADURAI/>}/>
            <Route path='/samsung-washing-machine-service-center' element={<SAMSUNGWASHINGMACHINESERVICECENTER/>}/>
            <Route path='/samsung-washing-machine-service-in-madurai' element={<SAMSUNGWASHINGMACHINESERVICEINMADURAI/>}/>
            <Route path='/samsung-washing-machine-service-madurai' element={<SAMSUNGWASHINGMACHINESERVICEMADURAI/>}/>
             <Route path='/samsung-washing-machine-service' element={<SAMSUNGWASHINGMACHINESERVICE/>}/>
            <Route path='/whirlpool-washing-machine-service-center-in-madurai' element={<WHIRLPOOLWASHINGMACHINESERVICECENTERINMADURAI/>}/>
            <Route path='/whirlpool-washing-machine-service-center-madurai' element={<WHIRLPOOLWASHINGMACHINESERVICECENTERMADURAI/>}/>
            <Route path='/whirlpool-washing-machine-service-center' element={<WHIRLPOOLWASHINGMACHINESERVICECENTER/>}/>
            <Route path='/whirlpool-washing-machine-service-in-madurai' element={<WHIRLPOOLWASHINGMACHINESERVICEINMADURAI/>}/>
            <Route path='/whirlpool-washing-machine-service-madurai' element={<WHIRLPOOLWASHINGMACHINESERVICEMADURAI/>}/>
            <Route path='/whirlpool-washing-machine-service-center-near-me' element={<WHIRLPOOLWASHINGMACHINESERVICECENTERNEARME/>}/>
        <Route path='/whirlpool-washing-machine-service-near-me' element={<WHIRLPOOLWASHINGMACHINESERVICENEARME />} />


            <Route path='/whirlpool-washing-machine-service' element={<WHIRLPOOLWASHINGMACHINESERVICE/>}/>
            <Route path='/bosch-washing-machine-service-center-in-madurai' element={<BOSCHWASHINGMACHINESERVICECENTERINMADURAI/>}/>
            <Route path='/bosch-washing-machine-service-center-madurai' element={<BOSCHWASHINGMACHINESERVICECENTERMADURAI/>}/>
            <Route path='/bosch-washing-machine-service-center' element={<BOSCHWASHINGMACHINESERVICECENTER/>}/>
            <Route path='/bosch-washing-machine-service-in-madurai' element={<BOSCHWASHINGMACHINESERVICEINMADURAI/>}/>
            <Route path='/bosch-washing-machine-service-madurai' element={<BOSCHWASHINGMACHINESERVICEMADURAI/>}/> 
           
            <Route path='/bosch-washing-machine-service' element={<BOSCHWASHINGMACHINESERVICE/>}/>
            <Route path='/bosch-washing-machine-service-near-me' element={<BOSCHWASHINGMACHINESERVICENEARME/>}/>
            <Route path='/haier-washing-machine-service-near-me' element={<HAIERWASHINGMACHINESERVICENEARME/>}/>
            <Route path='/ifb-washing-machine-service-near-me' element={<IFBWASHINGMACHINESERVICENEARME/>}/>
            <Route path='/lg-washing-machine-customer-care' element={<LGWASHINGMACHINECUSTOMERCARE/>}/>
            <Route path='/lg-washing-machine-service-near-me' element={<LGWASHINGMACHINESERVICENEARME/>}/>
            <Route path='/samsung-washing-machine-service-near-me' element={<SAMSUNGWASHINGMACHINESERVICENEARME/>}/>
           

          <Route path='/bosch-washing-machine-service-center-near-me' element={<BOSCHWASHINGMACHINESERVICECENTERNEARME/>}/>
          <Route path='/haier-washing-machine-service-center-near-me' element={<HAIERWASHINGMACHINESERVICECENTERNEARME/>}/>
          <Route path='/ifb-washing-machine-service-center-near-me' element={<IFBWASHINGMACHINESERVICECENTERNEARME/>}/>
          <Route path='/lg-washing-machine-service-center-near-me' element={<LGWASHINGMACHINESERVICECENTERNEARME/>}/>
          <Route path='/samsung-washing-machine-service-center-near-me' element={<SAMSUNGWASHINGMACHINESERVICECENTERNEARME/>}/>
          <Route path='/lg-customer-care-madurai' element={<LGCUSTOMERCAREMADURAI/>}/>
          <Route path='/whirlpool-customer-care-madurai' element={<WHIRLPOOLCUSTOMERCAREMADURAI/>}/>
          {/* <Route path='/samsung-customer-care-madurai' element={<SAMSUNGHOMEAPPLICANCESERVICEMADURAI/>}/> */}
          <Route path='/samsung-customer-care-madurai' element={<SAMSUNGCUSTOMERCAREMADURAI/>}/>
          <Route path='/haier-customer-care-madurai' element={<HAIERCUSTOMERCAREMADURAI/>}/>
          <Route path='/bosch-customer-care-madurai' element={<BOSCHCUSTOMERCAREMADURAI/>}/>


            <Route path='/privacy-policy' element={<PRIVACYPOLICY />} />
            <Route path='/terms-conditions' element={<TERMSCONDITIONS />} />
            
     
          </Routes>
        </div>
      </Router>

      <section id='FIXEDPHONECALL'>
  <a href='tel:+91777 000 5768' id='phone-call-button'>
    <i class='fa fa-phone'></i>
  </a>
</section>


    </>
  );
}

export default App;
